export default __webpack_public_path__ + "static/media/arrow.858d1ba7.svg";